export default __webpack_public_path__ + "static/media/include_2_male@2x.f3837244.jpg";